import { AreaTreeCore } from './Core'
import { AreaTreeProps } from './interface'
import { AreaTreeStoreProvider } from './Store'
import { AreaTreeToolbar } from './Toolbar'

export const AreaTree = ({
  /* -------------------------------------------------------------------------- */
  /*                         AreaTreeStoreProvider Props                        */
  /* -------------------------------------------------------------------------- */
  value,
  onChange
}: AreaTreeProps) => {
  return (
    <AreaTreeStoreProvider value={value} onChange={onChange}>
      <AreaTreeToolbar />
      <AreaTreeCore />
    </AreaTreeStoreProvider>
  )
}
